import React, { useEffect } from "react";
import AccountDetailsForm from "../AccountOverview/AccountDetailsForm";
import RecentTransactions from "./../AccountOverview/RecentTransaction";
import QuickActions from "./../AccountOverview/QuickAction";
import FAQSupportComponent from "./../AccountOverview/FaqComponent";
import AccountDashboard from "./../AccountOverview/Dashboard";
import {
  SkeletonBox,
  SkeletonFAQSupport,
  SkeletonLoader,
  SkeletonQuickActions,
} from "./../../Components/skeleton";
import { useOverview } from "../../hooks";
import Footer from "./../../Components/Footer";
import DebitCard from "./DebitCard";

function AccountOverview({ noPayment, setIsOpen, setCurrentFlow }) {
  const {
    mainCurrencies,
    setNoPayment,
    // react query
    usePartnerHealth,
    useGlobalAccount,
    useTransactionDetails,
    useCardDetails,
    partnerHealthDisable,
    setPartnerHealth,
  } = useOverview();

  const { error: partnerHealth } = usePartnerHealth();
  const { data: cardDetailsResponse, error: cardDetailsError, isLoading: isLoadingCard, isFetching: isFetchingCard } = useCardDetails();

  useEffect(() => {
    if (partnerHealth?.errorCode === "MCB0059") {
      setPartnerHealth(true);
    } else {
      setPartnerHealth(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerHealth]);

  const { data: globalData, isLoading: globalDataIsLoading } =
    useGlobalAccount();
  const { data: transactionDataList, isLoading: setTransactionDataIsLoading } =
    useTransactionDetails();

  const shouldHideDebitCard =
    cardDetailsError?.message ===
      "Card details not found, please contact customer support for more information.";

  useEffect(() => {
    setNoPayment(mainCurrencies?.length === 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainCurrencies]);

  return (
    <>
      <div
        className={`h-[calc(100dvh-114px)] lg:h-[calc(100dvh-146px)] overflow-scroll  lg:pt-10  `}
      >
        {globalDataIsLoading ? (
          <SkeletonLoader />
        ) : (
          <AccountDashboard
            setIsOpen={setIsOpen}
            noPayment={noPayment}
            data={globalData?.data}
            partnerHealthDisable={partnerHealthDisable}
          />
        )}

        {partnerHealth?.errorCode === "MCB0059" && (
          <div className=" lg:mx-40 mr-40 overflow-hidden">
            <div className=" py-2 flex animate-marquee whitespace-nowrap">
              <span className="text-md text-red-500 mx-4">
                {partnerHealth?.message}
              </span>
            </div>
          </div>
        )}

        {!shouldHideDebitCard && (
          <DebitCard
            setIsOpen={setIsOpen}
            setCurrentFlow={setCurrentFlow}
            cardDetailsResponse={cardDetailsResponse}
            isLoadingCard={isLoadingCard}
            isFetchingCard={isFetchingCard}
          />
        )}

        <div
          className={`flex  lg:!mx-40 flex-col xl:flex-row lg:gap-10 ${
            partnerHealth?.errorCode === "MCB0059" ? "lg:pb-8" : "lg:py-8"
          }`}
        >
          <div className="  border-t lg:border-t-0 xl:w-1/2 ">
            {setTransactionDataIsLoading ? (
              <SkeletonBox />
            ) : (
              <RecentTransactions
                noPayment={noPayment}
                data={transactionDataList?.data?.transactions}
              />
            )}
          </div>
          <div className=" border-t lg:border-t-0 xl:w-1/2 ">
            {globalDataIsLoading ? (
              <SkeletonBox />
            ) : (
              <AccountDetailsForm
                noPayment={noPayment}
                data={globalData?.data}
              />
            )}
          </div>
        </div>
        <div className=" border-t-2  lg:!mx-40 mb-[24px] lg:mb-[33px] lg:border-t-0">
          {globalDataIsLoading ? (
            <SkeletonQuickActions />
          ) : (
            <QuickActions
              setIsOpen={setIsOpen}
              partnerHealthDisable={partnerHealthDisable}
            />
          )}
        </div>
        {globalDataIsLoading ? <SkeletonFAQSupport /> : <FAQSupportComponent />}
        <Footer />
      </div>
    </>
  );
}

export default AccountOverview;
